export default __webpack_public_path__ + "static/media/ISSO CLASS-5_SYLLABUS_2025-26.30dd0de3.pdf";